import * as React from "react";
import { Table, TableHeader, TableBody, TableHead, TableRow, TableCell } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const procedures = [{
  id: 1,
  name: "Standard Consultation & Examination",
  cost: "€60.00",
  reimbursement: "€60.00"
}, {
  id: 2,
  name: "Scale and Polish (Hygienist)",
  cost: "€75.00",
  reimbursement: "€42.00"
}, {
  id: 3,
  name: "Amalgam Filling (Standard)",
  cost: "€95.00",
  reimbursement: "€55.00"
}, {
  id: 4,
  name: "Composite Filling (White, Front Tooth)",
  cost: "€130.00",
  reimbursement: "€75.00"
}, {
  id: 5,
  name: "Routine Extraction",
  cost: "€110.00",
  reimbursement: "€60.00"
}, {
  id: 6,
  name: "Surgical Extraction",
  cost: "€180.00",
  reimbursement: "€110.00"
}, {
  id: 7,
  name: "Root Canal Treatment (Incisor)",
  cost: "€380.00",
  reimbursement: "€200.00"
}, {
  id: 8,
  name: "Advanced Periodontal Treatment (Per Quadrant)",
  cost: "€150.00",
  reimbursement: "€80.00"
}];
export default function ProceduresAndHseReimbursement() {
  return <section id="procedures-and-hse-reimbursement" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4">
            Procedures and HSE Reimbursement
          </h2>
          <p className="text-lg text-muted-foreground font-default max-w-2xl mx-auto">
            Transparent pricing for our most common treatments, including the estimated amount you can claim back through the HSE scheme.
          </p>
        </div>

        <div className="rounded-lg border border-border overflow-hidden shadow-md bg-background">
          <Table>
            <TableHeader className="bg-primary">
              <TableRow className="hover:bg-primary border-none">
                <TableHead className="text-primary-foreground font-bold font-default text-base h-14 w-1/2 align-middle">
                  Procedure
                </TableHead>
                <TableHead className="text-primary-foreground font-bold font-default text-base h-14 text-center w-1/4 align-middle">
                  Your Cost
                </TableHead>
                <TableHead className="text-primary-foreground font-bold font-default text-base h-14 text-center w-1/4 align-middle">
                  HSE Reimburses
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {procedures.map((item, i) => <TableRow key={item.id} data-index={i} className="even:bg-muted odd:bg-background border-border hover:bg-accent/30 transition-colors">
                  <TableCell className="font-default text-foreground py-4 text-base align-middle">
                    {item.name}
                  </TableCell>
                  <TableCell className="font-default font-medium text-foreground text-center py-4 text-base align-middle">
                    {item.cost}
                  </TableCell>
                  <TableCell className="font-default font-medium text-chart-2 text-center py-4 text-base align-middle">
                    {item.reimbursement}
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>

        <div className="mt-12 text-center">
          <Button asChild size="lg" className="font-default font-semibold rounded-full">
            <Link to="#">View All Treatments</Link>
          </Button>
        </div>
      </div>
    </section>;
}